module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ep-top",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("The term “global warming” is as misleading as it is inaccurate. True, the overall temperature of the earth as measured by annual average readings will rise. But averages tell us next to nothing. A shortening of a rainy season by two weeks in a given area might be reflected by an increase in the average annual temperature of only a third of a degree. But the impact on the water supply—and thus the growing season—would be considerably higher.")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Paradoxically, rapid climate change may bring much lower temperatures in many places. It should also be noted that some changes may well benefit people in the affected areas, at least temporarily, by extending growing seasons, negating weather extremes, or having some other unpredictable effect.")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Unfortunately, the sensationalistic term, combined with the slow evolution of the effects prior to the crisis point, will make it hard to convince the general population of the true danger.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("—Int. Soc. of Environmental Scientists report")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 68
// module chunks = 0